import React from "react";
import Modal from '@mui/material/Modal';
import "../../../css/VUP_dash.css";
import { MngTgModal } from "./FxMoDetail"

export const FxMoDash = (props) => {
  const { setMngTgModal, open, plantObj } = props;
  const handleClose = () => {
    setMngTgModal(false);
  }

  console.log("plantObj >>>>", plantObj);

  return (
    <>
      {open ? (<>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popupBasic" style={{ width: "1000px", minheight: "500px", top: "15%" }}>
            <div className="closeBtn" onClick={handleClose}>
              <img src="../svgCloseBtn.svg" />
              <img src="../svgCloseBtn_on.svg" />
            </div>
            < MngTgModal plantObj={plantObj} />
          </div>
        </Modal>
      </>) : null}
    </>

  );
}

